module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-informations-new",
    style: ([{
      marginLeft: _vm.marginLeft
    }]),
    attrs: {
      "id": "list-informations-new"
    }
  }, [(this.$route.name === 'segment' && _vm.slide !== null) ? _c('b-row', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "arrow-panel imgClickAndChange",
    on: {
      "click": _vm.showPanel
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), (_vm.slide) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('panels.infos.name_screen')) + "\n    " + _vm._s(_vm.slide.title) + " | " + _vm._s(_vm.$t('panels.infos.duration_screen')) + "\n    " + _vm._s(_vm._f("FormatTime")(_vm.slide.options.duration)) + "\n    \n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$route.name !== 'segment' && _vm.segment !== null) ? _c('b-row', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "arrow-panel imgClickAndChange",
    on: {
      "click": _vm.showPanel
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), (_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('panels.infos.name_segment')) + "\n    " + _vm._s(_vm.segment.title) + " | " + _vm._s(_vm.$t('panels.infos.name_screen')) + _vm._s(_vm.slide.title) + " |\n    " + _vm._s(_vm.$t('panels.infos.duration_segment')) + "\n    " + _vm._s(_vm._f("FormatTime")(_vm.segment.duration)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('panels.infos.name_screen')) + _vm._s(_vm.slide.title) + " |\n    " + _vm._s(_vm.$t('panels.infos.duration_screen')) + "\n    " + _vm._s(_vm.FormatTime) + "\n      ")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28513504","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformationsCanvas.vue
// module id = 820
// module chunks = 1 3